import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

interface VehicleDetailSpecsProps {
  vehicle: any;
  formatPrice: (price: number) => string;
}

function SpecGrid({ rows }: { rows: { label: string; value: string }[] }) {
  if (!rows.length) return null;

  return (
    <dl className="wl6-vd-specs-grid">
      {rows.map((row) => (
        <div key={row.label} className="wl6-vd-spec-row">
          <dt>{row.label}</dt>
          <dd>{row.value}</dd>
        </div>
      ))}
    </dl>
  );
}

export function VehicleDetailSpecs({
  vehicle,
  formatPrice,
}: VehicleDetailSpecsProps) {
  const generalRows: { label: string; value: string }[] = [
    { label: 'Marca', value: vehicle.brand },
    { label: 'Modelo', value: vehicle.model },
  ];

  if (vehicle.version) generalRows.push({ label: 'Versão', value: vehicle.version });
  generalRows.push({ label: 'Condição', value: vehicle.isZeroKm ? 'Zero KM' : 'Seminovo' });
  generalRows.push({ label: 'Preço', value: formatPrice(vehicle.price) });

  return (
    <section className="wl6-vd-section wl6-vd-specs">
      <div className="wl6-vd-section__head">
        <p className="wl6-eyebrow">Ficha técnica</p>
        <h2 className="wl6-vd-section__title wl6-h2">Especificações</h2>
      </div>

      <Accordion type="multiple" defaultValue={['general']} className="w-full">
        <AccordionItem value="general">
          <AccordionTrigger className="wl6-vd-accordion-trigger">Identificação e valor</AccordionTrigger>
          <AccordionContent>
            <SpecGrid rows={generalRows} />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </section>
  );
}
